import { FormattedReport } from "../../Shared/Report";
import LandUseProportionCard from '../../LandInfraDevelopment/Head/DashboardDetail/LandUseProportionCard';
import ShedParcelRatioCard from '../../LandInfraDevelopment/Head/DashboardDetail/ShedParcelRatioCard';
const department = "operation";
const reports = [
  { access: "activeContracts", title: "Active Contracts" },
  { access: "invActQuarterly", title: "Quarterly Report" },
  { access: "invByIndustry", title: "Investment by Industry" },
  //***** */
  { access: "invActQuarterly", title: "Investor Activity Report" },

  { 
    access: "landUseProportion", 
    title: "Land Use Proportion",
    component: LandUseProportionCard 
  },
  { 
    access: "shedParcelRatio", 
    title: "Shed Vs Parcel Ratio",
    component: ShedParcelRatioCard 
  },
  // *****Error in the report Investor Summary
  // { access: "invSummary", title: "Investor Summary" },

  { access: "arrears", title: "Arrear Report" },
  // { access: "overdue", title: "Overdue Report" },
  // { access: "dues", title: "Payments Due Report" },
   { access: "collected", title: "collected Report" },
  { access: "financialSummary", title: "Financial Summary" },
];
export default function ParkStaffReports() {
  return <FormattedReport reports={reports} department={department} />;
}


